import React from 'react';
import * as S from './Footer.styles'
import { PrimaryButton, SecondaryButton } from './../../common/Form/Button/Button';
import {REPORT_SUBCOMPONENTS} from './../config'
import classNames from 'classnames';
export const Footer = ({data,onClickCb,padding='',isFooterDisabled=false})=>{
    if(!data || !Array.isArray(data)){
        return null;
    }
    const renderSubComponent = (item,index) =>{
        const subComponentName = item?.component
     switch(subComponentName){
        case REPORT_SUBCOMPONENTS.BUTTON:
            return (<PrimaryButton className={classNames(item?.style?.customClasses)} key={index+subComponentName} disabled={isFooterDisabled} padding={padding} onClick={()=>{
                if(!isFooterDisabled){
                    onClickCb(item?.data?.action)
    
                }
            }}>
           {item?.data?.label || ""}
        </PrimaryButton>)
        case REPORT_SUBCOMPONENTS.SECONDARY_BUTTON:
            return (<SecondaryButton   className={classNames(item?.style?.customClasses)}   key={index+subComponentName} onClick={()=>{
                if(!isFooterDisabled){
                    onClickCb(item?.data?.action)

                }
            }}>
            {item?.data?.label}
        </SecondaryButton>)
        default:
            return null;
     }
    }
    const renderComponent = (data) =>{
        return data?.map((item,index)=>{
       return  renderSubComponent(item,index)
        })
    }
    return <S.ActionContainer>{renderComponent(data)}</S.ActionContainer>
}

